// extracted by mini-css-extract-plugin
module.exports = {"container":"WidgetLayout_container__vqRBJ","layout":"WidgetLayout_layout__2geFS","example":"WidgetLayout_example__2CPwi"};